export default "/_next/static/images/66409001ac7a3196f352ccf097c74692.svg";